/**
 * P0.7 — export do Gingado (CSV) gerado 100% client-side. Legível pelo
 * psicomotricista / TO / fisio, sem jargão do app. Reusa baixarCSV (web/nativo) do
 * módulo base.
 */
import {
  AJUDA_LABEL,
  CONTEXTO_LABEL,
  ESTADO_REGULACAO_LABEL,
  ORIGEM_LABEL,
  PARTICIPACAO_LABEL,
  type AtividadePsicomotora,
  type MomentoPsicomotor,
} from "./types";

function csvCampo(v: string | number | null | undefined): string {
  const s = v === null || v === undefined ? "" : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** CSV dos momentos psicomotores. Separador ";" (Excel PT-BR). */
export function momentosParaCSV(
  momentos: MomentoPsicomotor[],
  atividades: AtividadePsicomotora[],
): string {
  const nome = (id: string) => atividades.find((a) => a.id === id)?.nome ?? id;
  const cab = [
    "data e hora",
    "atividade",
    "participação (passo)",
    "passo nº",
    "nível de ajuda",
    "estado antes",
    "estado depois",
    "duração (min)",
    "contexto",
    "origem",
    "confirmado",
    "notas",
  ];
  const linhas = momentos
    .slice()
    .sort((a, b) => a.data_hora.localeCompare(b.data_hora))
    .map((m) =>
      [
        new Date(m.data_hora).toLocaleString("pt-BR"),
        nome(m.atividade_id),
        PARTICIPACAO_LABEL[m.passo_participacao],
        m.passo_participacao,
        m.nivel_ajuda ? AJUDA_LABEL[m.nivel_ajuda] : null,
        m.estado_antes ? ESTADO_REGULACAO_LABEL[m.estado_antes] : null,
        m.estado_depois ? ESTADO_REGULACAO_LABEL[m.estado_depois] : null,
        m.duracao_min,
        m.contexto ? CONTEXTO_LABEL[m.contexto] : null,
        ORIGEM_LABEL[m.origem],
        m.confirmado ? "sim" : "pendente",
        m.notas,
      ]
        .map(csvCampo)
        .join(";"),
    );
  return [cab.join(";"), ...linhas].join("\r\n");
}
